import { render } from "./UserModal.vue?vue&type=template&id=15656e12&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"

import "./UserModal.vue?vue&type=style&index=0&id=15656e12&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15656e12"

export default script